import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { FiltroGuiaComponent } from "./filtro";
import { Multiselector } from "app/features/componentes/multiselector";
import { columnasFijas } from "../../guias/listados/guias/list/listmem";

type Column = kea.Grid2Column<models.GuiaDTO>;
/**Obtiene las columnas del grid */
function columnas(): Column[] {
    return [...columnasFijas];
}

interface State {
    value: string[];
    filtro: Partial<models.FiltroGuia>;
}

export class FacturarGuiasList extends React.PureComponent<{}, State> {
    constructor(state: State) {
        super(state);
        this.state = {
            value: [], filtro: {
                Limite: 100,
                ImporteMayorCero: true,
                EsCancelada: false,
                EsDeCredito: false,
                StatusGuiaFacturacion: models.StatusGuiaFacturacion.NoFacturada
            }
        };
    }

    onSeleccionar = (value: string[]) => new Promise<void>(resolve => this.setState({ value: value }, resolve));

    onFiltroChange = (filtro: models.FiltroGuia) => new Promise<void>(resolve => this.setState({ filtro: filtro }, resolve));

    onFacturarGuias = async () => {
        const guias = this.state.value;
        if (await kea.yesno("¿Facturar estas guías?")) {
            var idFactura = await resources.FacturacionGuia.FacturarGuias(guias)
            history.go(`../facturas/${idFactura}`);
        }
    }

    limpiarfiltros = () => {
        this.setState({ filtro: {
            Limite: 100,
            ImporteMayorCero: true,
            EsCancelada: false,
            EsDeCredito: false,
            StatusGuiaFacturacion: models.StatusGuiaFacturacion.NoFacturada
        } });
    }

    onFacturarGuiasSinTimbrar = async () => {
        const guias = this.state.value;
        if (await kea.yesno("¿Facturar estas guías sin timbrar?")) {
            var idFactura = await resources.FacturacionGuia.FacturarGuiasSinTimbrar(guias)
            history.go(`../facturas/${idFactura}`);
        }
    }

    onFacturarGuiasPublicoGeneral = async () => {
        const guias = this.state.value;
        if (await kea.yesno("¿Facturar estas guías de personas morales como de publico general?")) {
            var idFactura = await resources.FacturacionGuia.FacturarGuiasPublicoGeneral(guias);
            history.go(`../facturas/${idFactura}`);
        }
    }

    /**Función que carga las guias */
    loadFunction = kea.loadItemsFuncFromResource(
        filtro => observeResource(resources.Guia.Query, filtro),
        id => observeResource(resources.Guia.Get, id),
        x => x.Folio,
        x => true);

    filtro = (x: State) => x.filtro;
    filtroEff = createSelectorRx(this.filtro, (filtro) => ({
        ...filtro,
    } as models.FiltroGuia));

    value = (x: State) => x.value;
    haySeleccionadas = (x: State) => x.value.length > 0;
    cant = (x: State) => x.value.length;
    guias = createSelectorRx(this.filtroEff, this.value, (filtro, value) => this.loadFunction(filtro as models.FiltroGuia, value));


    onRegresar = () => history.go('../');
    render() {
        const guias = this.guias(this.state);
        const cant = this.cant(this.state);
        const haySeleccionadas = this.haySeleccionadas(this.state);
        const cols = columnas();
        return (
            <div>
                <kea.Title titulo="Facturar guías" onRegresar={this.onRegresar} >
                    {
                        haySeleccionadas ?
                            <span className="badge">{cant}</span> : null
                    }
                    <kea.Button style="info" children="Facturar guías (sin timbrar)" onClick={this.onFacturarGuiasSinTimbrar} disabled={!haySeleccionadas} />
                    <kea.Button style="success" children="Facturar y timbrar guías" onClick={this.onFacturarGuias} disabled={!haySeleccionadas} />
                    <kea.Button style="warning" children="Facturar guías personas morales como publico general" onClick={this.onFacturarGuiasPublicoGeneral} disabled={!haySeleccionadas} />
                    <kea.Button style="default" children="Limpiar campos" onClick={this.limpiarfiltros}/>
                </kea.Title>
                <FiltroGuiaComponent value={this.state.filtro as models.FiltroGuia} onChange={this.onFiltroChange} />
                <Multiselector
                    value={this.state.value || []}
                    onChange={this.onSeleccionar}
                    getKey={(x: models.GuiaDTO) => x.Folio}
                    items={guias}
                    columnas={cols} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturarguias/list/list.tsx